var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"monitaBtn"},on:{"click":_vm.openComplaints}},[_c('i',{staticClass:"icon icon-menu"}),_vm._v(" "+_vm._s(_vm.$t('terms.openComplaintsList'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }